var accessTokenId;
var vertex_Expires;
(function(){
  // access token gererate
  var idleTimeout = 30*60*1000;
   var error = false;
      var cId = "1e0d8587f9894060b3827233fa445b62";
      var cs = "bb49e12d5f904f30b5817b1c63897658";
      var sc = "2Zbo38QL6w";
      var bc = "GLD";
      var details = {
          'client_id': cId,
          'client_secret': cs,
          'grant_type': 'client_credentials',
          'scope': 'vtms-internal-api ecw-wizard-api'
      };
      var formBody = [];
      for (var property in details) {
          var encodedKey = encodeURIComponent(property);
          var encodedValue = encodeURIComponent(details[property]);
          formBody.push(encodedKey + "=" + encodedValue);
      }
      formBody = formBody.join("&");
      axios.get('https://ecwportal.vertexsmb.com/ecw-service/commons/getAuthEndpoint')
               .then(function(response) {return response})
               .then(function(data){
                   var cloud_auth = data.data.cloud_auth_domain
                   var cloud_token_url = "https://"+cloud_auth+"/identity/connect/token"
    
                   axios({
                       method: 'post',
                       url : cloud_token_url,
                       data: formBody, // data can be `string` or {object}!
                       config: { headers: {'Content-Type': 'multipart/form-data' }}
                    }).then(function(response) {return response})
                      .then(function(data){
                        if(data.data.access_token) {
                          accessTokenId = data.data.access_token;
                          vertex_Expires = new Date().getTime() + idleTimeout;
                          console.log("accessTokenId-->",accessTokenId,"vertex_Expires-->",vertex_Expires)
                        }
                      })
                })

          // end
          setTimeout(function(){ 
            var token = accessTokenId;
            var expires = vertex_Expires;
            console.log("expires-->",expires,"token-->",token)
            var userClient = "2Zbo38QL6w";
            if(userClient){
                $('#clientId').value = userClient
            }
            var idleWarningTimeout= 1*60*1000;
            var warningTimeout;
        
            overRides = [{
                qId:2, value: ''
            },{
                qId:3, value: ''
            },{
                qId:4, value: ''
            },{
                qId:5, value: ''
            },{
                qId:6, value: ''
            },{
                qId:7, value: ''
            },{
                qId:19, value: ''
            },{
                qId:22, value: ''
            }]
        
            btn = new vertex.Wizard({
                wizardPath: "https://ecwportal.vertexsmb.com/wizard/",
                domNode: document.getElementById('vertaxDemo'),
                accessToken:token,
                clientCode: "2Zbo38QL6w",
                sellerCodes: ["GLD"],
                buyerCode: "GLD",
                overrides: overRides
            });
          }, 1000);
})();



